import {
  styled as muiStyled,
  Button,
  Stack,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';

import DownloadIcon from './icons/DownloadIcon';

import { COLORS } from '../../../../themes/colors';
import styled from 'styled-components';

export const Wrapper = muiStyled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '8px 0px',
}));

export const DownloadText = styled.div`
  text-transform: uppercase;
  font-family: 'Work Sans';
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
`;

export const BTNStyle = muiStyled(Button)(() => ({
  minWidth: 'unset',
  width: '40px',
  height: '40px',
  borderRadius: '2px',
}));

export const BTNIcon = muiStyled(DownloadIcon)(() => ({
  width: '18px',
  height: '18px',
  fill: `${COLORS.WHITE}`,
}));

export const MenuStyled = muiStyled(Menu)(() => ({
  '& .MuiPaper-root': {
    marginTop: '8px',
    marginRight: '8px',
    borderRadius: '8px',
    width: '301px',
  },
}));

export const MenuItemStyled = muiStyled(MenuItem)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 32,
  margin: '8px 0',
}));

export const LabelStyled = muiStyled(Typography)(() => ({
  color: `${COLORS.PRIMARY.BLUE.MAIN}`,
}));

export const LabelSugestion = muiStyled(Typography)(() => ({
  color: `${COLORS.GRAY['-9']}`,
  fontStyle: 'italic',
  display: 'inline',
  marginLeft: '10px',
}));

export const DownloadIconStlyed = muiStyled(DownloadIcon)(() => ({
  width: '18px',
  height: '18px',
  fill: `${COLORS.PRIMARY.BLUE['-3']}`,
  marginLeft: '8px',
}));
